// 统一加前缀tw
// 这里对全局维护的变量进行维护和初始化；这里的数据和变量加前缀store；与数据变化需要出发的方法也需要在这里进行注册，不然无法触发

// 性别数据
let tw_store_gender = "all";
const tw_store_gender_func = [twSetGenderClass, twSetGenderList];

// 更新性别数据
function twStoreSetGenger(new_gender) {
  tw_store_gender = new_gender;
  twSetData(TW_GENDER_KEY, tw_store_gender);

  twStoreGenderTriggerFunc();
}

// 根据性别设置导航
function twSetGenderClass(gender) {
  $(".tw-gender").removeClass("tw-gender-active");
  if (gender !== "all") {
    $(".tw-gender-" + gender).addClass("tw-gender-active");
  }
}

// 根据性别切换所有的性别相关的列表数据
function twSetGenderList(gender) {
  $(".tw-product-grid").css("display", "none");
  $(".tw-product-grid-" + gender).css("display", "flex");
}

function twStoreGenderTriggerFunc() {
  tw_store_gender_func.forEach(function (func) {
    if (func && typeof func === "function") {
      func(tw_store_gender);
    }
  });
}

$(document).ready(function () {
  // 初始化性别设置
  let default_gender = twGetData(TW_GENDER_KEY);

  if (!default_gender) {
    default_gender = "all";
  }
  twStoreSetGenger(default_gender);

  // 切换性别点击事件
  $(".tw-gender").click(function () {
    let cur_gender = $(this).data("gender");
    if (cur_gender === tw_store_gender) {
      twStoreSetGenger("all");
    } else {
      twStoreSetGenger(cur_gender);
    }
  });
});
